export enum BrotherPrintEventsEnum {
  onPrinterAvailable = 'onPrinterAvailable',
  onPrint = 'onPrint',
  onPrintFailedCommunication = 'onPrintFailedCommunication',
  onPrintError = 'onPrintError',
  onPrinterStatus = 'onPrinterStatus',
}
